/* eslint-disable */ 

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, Injector } from '@angular/core';
import {
  ApiClientBase,
  API_BASE_URL
} from '@mds/angular-core-material';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AppointmentClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
    injector: Injector
  ) {
    super(injector);
  }

  getConfig(throwError?: boolean): Observable<AppointmentConfigModel> {
      let url = this.baseUrl + '/appointment/config';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppointmentConfigModel>(url, this.jsonOptions), throwError);
  }

  getOrder(throwError?: boolean): Observable<OrderModel> {
      let url = this.baseUrl + '/appointment/order';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<OrderModel>(url, this.jsonOptions), throwError);
  }

  getAppointmentSlotsGrouped(throwError?: boolean): Observable<AppointmentDay[]> {
      let url = this.baseUrl + '/appointment/slots';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<AppointmentDay[]>(url, this.jsonOptions), throwError);
  }

  bookAdditionalServices(model: BookAdditionalServicesModel, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/appointment/additionalservices';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }

  bookAppointment(model: BookAppointmentModel, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/appointment';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class BrandingClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
    injector: Injector
  ) {
    super(injector);
  }

  getBranding(throwError?: boolean): Observable<BrandingStylesheetModel> {
      let url = this.baseUrl + '/branding';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<BrandingStylesheetModel>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConfigClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
    injector: Injector
  ) {
    super(injector);
  }

  config(throwError?: boolean): Observable<Configuration> {
      let url = this.baseUrl + '/config';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.get<Configuration>(url, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class SupportClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
    injector: Injector
  ) {
    super(injector);
  }

  contact(model: ContactSupportEmailModel, throwError?: boolean): Observable<void> {
      let url = this.baseUrl + '/support';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<void>(url, model, this.jsonOptions), throwError);
  }
}

@Injectable({
  providedIn: 'root'
})
export class TokenClient extends ApiClientBase {
  constructor(
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string,
    injector: Injector
  ) {
    super(injector);
  }

  createToken(model: CreateJwtTokenModel, throwError?: boolean): Observable<TokenModel> {
      let url = this.baseUrl + '/token';
    url = url.replace(/[?&]$/, '');

    return this.handleResponse(this.http.post<TokenModel>(url, model, this.jsonOptions), throwError);
  }
}

export interface AppointmentConfigModel {
    contact: ContactTemplateContent;
    division: DivisionType;
    bookingView: WebTemplateContent | undefined;
    depositNote: WebTemplateContent | undefined;
    additionalServices: ActiveAdditionalServiceModel[];
}

export interface ContactTemplateContent {
    email: string;
    phone: string | undefined;
}

export enum DivisionType {
    Undefined = 0,
    Cargo = 1,
    Homeservice = 2,
}

export interface WebTemplateContent {
    text: { [key: string]: string; };
}

export interface ActiveAdditionalServiceModel {
    additionalServiceId: number;
    additionalServiceLocalizations: AdditionalServiceLocalizedModel[];
}

export interface AdditionalServiceLocalizedModel {
    /** ISO 639-1 two-letter code for the language */
    cultureCode: string;
    name: string;
    remarks?: string | undefined;
}

export interface OrderModel {
    title: string;
    email: string;
    location: string;
    name: string;
    phoneNumber: string;
    street: string;
    address1: string;
    zipCode: number;
    parcelNumber: string;
    remarks: string;
    depositNote: string;
    scheduledItemArrival: Date | undefined;
    scheduledAppointment: Date | undefined;
    isAppointed: boolean;
    supportCases?: OrderSupportCases;
    state?: OrderState;
    division: DivisionType;
}

export enum OrderSupportCases {
    None = 0,
    NoZipCode = 1,
    NoLinkSent = 2,
    NoTimeslots = 4,
    AdditionalServices = 8,
    All = -1,
}

export enum OrderState {
    Undefined = 0,
    Unappointed = 1,
    Appointed = 2,
    Closed = 3,
    SoftDeleted = 4,
}

export interface AppointmentDay {
    day: Date;
    slots: AppointmentSlotModel[];
}

export interface AppointmentSlotModel {
    bringgSlotId?: string | undefined;
    orderTimeSlotId?: number | undefined;
    orderDayId?: number | undefined;
    fromTime: Date;
    toTime: Date;
}

export interface BookAdditionalServicesModel {
    email: string;
    location: string;
    name: string;
    phoneNumber?: string | undefined;
    street: string;
    address1?: string | undefined;
    zipCode: number;
    remarks?: string | undefined;
    depositNote?: string | undefined;
    additionalServiceIds: number[];
}

export interface BookAppointmentModel {
    bringgSlotId?: string | undefined;
    orderTimeSlotId?: number | undefined;
    orderDayId?: number | undefined;
    email: string;
    location: string;
    name: string;
    phoneNumber?: string | undefined;
    street: string;
    address1?: string | undefined;
    zipCode: number;
    remarks?: string | undefined;
    depositNote?: string | undefined;
}

export interface BrandingStylesheetModel {
    stylesheet?: string;
    branding?: BrandingModel;
}

export interface BrandingModel {
    id: number;
    brandingIdentifier: string;
    logo: string;
    primaryColor: string;
    secondaryColor: string;
    backgroundColor: string;
    fontType: FontType;
    isBrandingIdentifierReadOnly: boolean;
}

export enum FontType {
    Roboto = 0,
    OpenSans = 1,
}

export interface Configuration {
    appInsights: AppInsights;
    supportOptions?: SupportOptions | undefined;
    recaptchaOptions?: RecaptchaOptions | undefined;
}

export interface AppInsights {
    instrumentationKey?: string | undefined;
}

export interface SupportOptions {
    email: string;
    phone: string;
    adminLinkTemplate: string;
}

export interface RecaptchaOptions {
    siteKey: string;
}

export interface ContactSupportEmailModel {
    token: string;
    name: string;
    email: string;
    phoneNumber: string | undefined;
    street: string | undefined;
    zipCode: string;
    location: string;
    parcelNumber: string | undefined;
    remarks: string;
}

export interface TokenModel {
    jwtToken: string;
}

export interface CreateJwtTokenModel {
    token: string;
}